import { countryCodes } from '@data/globalData';

export const countriesOptions = countryCodes.map(code => ({
    label: code.toCountryDisplayName() ?? code,
    value: code,
}));
